import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Map from '../components/Map'
import List from '../components/List/List'
import styled from 'styled-components'
import { Box, Flex, ScreenSwitch } from '@elparking/components'

import { getViatHighwayDiscounts } from 'commons/js/api'
import { useApi } from '@elparking/utils'

const Layout = styled.div`
    min-height: 600px;
    display: grid;
`

const ListContainer = styled(Box)`
    height: 100%;
    box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.1);
`

const MapLayout = styled.div`
    height: calc(100% - 3em);
    margin-top: 1.5em;
    width: 50%;
`

const FullSizeContainer = <div style={{height: '100%', width: '100%'}} />

const MapContainer = ({ getViatHighwayDiscounts }) => {
    const [ location, setLocation ] = useState(null)

    const {
        response: { result: highways, error },
        sendRequest: requestViatHighwayDiscounts,
    } = useApi(getViatHighwayDiscounts)

    useEffect(() => {
        !highways && requestViatHighwayDiscounts()
    }, [highways, requestViatHighwayDiscounts])

    return (
        <Layout>
            <Flex flexWrap='wrap'>
                <ListContainer background='white' w={['100%', '50%']}>
                    <List
                      error={!!error}
                      location={location}
                      highways={highways || []}
                      setLocation={setLocation} />
                </ListContainer>
                <MapLayout>
                    <ScreenSwitch
                      medium={Map}
                      key={location}
                      highways={(highways || []).map((highway) => ({
                          ...highway,
                          selected: highway.location === location,
                      }))}
                      loadingElement={<div />}
                      containerElement={FullSizeContainer}
                      mapElement={FullSizeContainer}
                    />
                </MapLayout>
            </Flex>
        </Layout>
    )
}

MapContainer.propTypes = {
    getViatHighwayDiscounts: PropTypes.func,
}

MapContainer.defaultProps = {
    getViatHighwayDiscounts,
}

export default MapContainer
